// @codingStandardsIgnoreFile
import icon from './components/metaslider-icon'
import edit from './components/block-edit'
import save from './components/block-save'
const wp = window.wp
const {__} = wp.i18n
const {
	registerBlockType
} = wp.blocks

/**
 * Register Gutenberg Block
 *
 * @param  {string}   name     Block name.
 * @param  {Object}   settings Block settings.
 * @return {?WPBlock}          The block, if it has been successfully
 *                             registered; otherwise `undefined`.
 */
registerBlockType('metaslider/slider', {
	title: 'MetaSlider',
	description: __('Use MetaSlider to insert slideshows and sliders in your page', 'ml-slider'),
	icon: icon,
	category: 'common',
	keywords: [__('slider', 'ml-slider'), __('slideshow', 'ml-slider'), __('gallery')],
	attributes: {
		slider_id: {
			type: 'number',
			default: 0
		}
	},

	/**
	 * Edit function
	 */
	edit: props => edit(props),

	/**
	 *  The "save" property must be specified and must be a valid function.
	 *
	 * @param  {obj}  props
	 * @return {bool} false because content is dynamic (see php file)
	 */
	save: props => save(props)
})



// WEBPACK FOOTER //
// ./src/admin/assets/js/gutenberg/editor-block.js